import { Link, usePage, router } from "@inertiajs/react";
import { User } from "@/types/generated";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "./ui/navigation-menu";
import { LogOut, Settings, Menu, Gauge } from "lucide-react";

export function Navigation() {
  const { auth } = usePage<{ auth?: { user: User } }>().props;

  return (
    <nav className="w-full sticky top-0 z-50 bg-white">
      <div className="relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            href="/"
            className="flex items-center space-x-3 group transition-all duration-300 hover:scale-105"
          >
            <div>
              <h1 className="text-2xl font-bold text-black font-ocr">
                timing:tower
              </h1>
            </div>
          </Link>

          {auth?.user ? (
            <NavigationMenu viewport={false}>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <NavigationMenuTrigger>
                    <Menu className="md:hidden" />
                    <div className="hidden sm:block">
                      <div className="text-black font-xs font-ocr">
                        {auth.user.full_name}
                      </div>
                    </div>
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-white z-50 block">
                    <ul className="w-48 p-1 space-y-1 z-50">
                      <li>
                        <Link
                          href="/garage"
                          className="flex items-center gap-3 px-3 py-2 rounded-md hover:bg-accent hover:text-accent-foreground transition-colors"
                        >
                          <Gauge className="w-4 h-4" />
                          <span>Garage</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          href="/settings"
                          className="flex items-center gap-3 px-3 py-2 rounded-md hover:bg-accent hover:text-accent-foreground transition-colors"
                        >
                          <Settings className="w-4 h-4" />
                          <span>Settings</span>
                        </Link>
                      </li>
                      <li>
                        <button
                          onClick={() => router.delete("/logout")}
                          className="cursor-pointer w-full flex items-center gap-3 px-3 py-2 rounded-md hover:bg-accent hover:text-accent-foreground transition-colors text-left"
                        >
                          <LogOut className="w-4 h-4" />
                          <span>Logout</span>
                        </button>
                      </li>
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          ) : (
            <div className="flex gap-2">
              <Link
                href="/login"
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
              >
                Login
              </Link>
              <Link
                href="/register"
                className="px-4 py-2 text-sm font-medium text-white bg-black rounded-md hover:bg-gray-800 transition-colors"
              >
                Sign up
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
